import { useState } from "react";
import { IconThreeDots } from "antopolis-react-icons";
import { useGetInfo } from "antopolis-react-utils/hooks";

import { useUseOrientation } from "../../../../Utilities/Hooks/useUseOrientation";
import { useAxiosInstance } from "../../../../Utilities/Hooks/useAxiosInstance";
import { CreateButton } from "../../../Partials/Layout/CRUD/CreateButton/CreateButton";
import { CRUDTable } from "../../../Partials/Layout/CRUD/CRUDTable/CRUDTable";
import { CRUDTableHeader } from "../../../Partials/Layout/CRUD/CRUDTableHeader/CRUDTableHeader";
import { CRUDth } from "../../../Partials/Layout/CRUD/CRUDth/CRUDth";
import { ImageCell } from "../../../Partials/Layout/CRUD/ImageCell/ImageCell";
import {
  CRUDButton,
  EditButton,
  ViewButton,
} from "../../../Partials/Layout/CRUD/CRUDButtons/CRUDButtons";
import { Modal } from "../../../Partials/Elements/Modal/Modal";


import CreateWork from "./CreateWork";
import UpdateWork from "./UpdateWork";
import ViewWork from "./ViewWork";
import { useNavigate } from "react-router-dom";
import { RiImage2Fill } from "react-icons/ri";
import { ShortTextCell } from "../../../Partials/Layout/CRUD/ShortTextCell/ShortTextCell";

function OurWorks({ api }) {
  const enums = Object.freeze([
    "digital marketing",
    "website tech",
    "video editing animation",
    "branding graphics design",
  ]);
  const [showActionButton, setShowActionButton] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);
  const [targetID, setTargetID] = useState(null);

  const { portrait } = useUseOrientation();
  const axiosInstance = useAxiosInstance();
  const navigate = useNavigate();

  const { info: works } = useGetInfo({
    axiosInstance: axiosInstance,
    api: api,
    toggleFetch,
  });

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }

  return (
    <div className="screen_wrapper">
      <div className="screen_header">
        <h1 className="screen_heading">
          Our works ({works?.length} in total)
        </h1>
        <CreateButton
          screenTopicSingular={"Work"}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable>
        <CRUDTableHeader>
          <CRUDth th="Image" />
          <CRUDth th="Type" />
          <CRUDth th="Short Title" />
          <CRUDth th="Short Description" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>
        <tbody>

          {works?.map((work) => (
            <tr key={work._id}>
              <ImageCell imgSrc={work.image} />
              <ShortTextCell text={work?.type} />
              <ShortTextCell text={work?.cardImageTitle} />
              <ShortTextCell text={work?.cardImageDescription} />
              <td>
                <div className="action_buttons_wrapper">
                  <button
                    className="three_dots"
                    onClick={() => {
                      setShowActionButton(true);
                      setTargetID(work._id);
                    }}
                  >
                    <IconThreeDots />
                  </button>
                  {!portrait && (
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={work._id}
                        setTargetID={setTargetID}
                      />
                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={work._id}
                        setTargetID={setTargetID}
                      />
                      <CRUDButton
                        handleClick={() => {
                          navigate("/main/workAssets/" + work._id);
                        }}
                      >
                        <RiImage2Fill />
                      </CRUDButton>

                    </div>
                  )}
                  {portrait && showActionButton && targetID === work._id && (
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={work._id}
                        setTargetID={setTargetID}
                      />
                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={work._id}
                        setTargetID={setTargetID}
                        setShowActionButton={setShowActionButton}
                      />
                      <CRUDButton
                        handleClick={() => {
                          navigate("/main/workAssets/" + work._id);
                        }}
                      >
                        <RiImage2Fill />
                      </CRUDButton>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </CRUDTable>

      {showCreateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Create work`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateWork
            setShowCreateForm={setShowCreateForm}
            triggerFetch={triggerFetch}
            api={api}
            types={enums}
          />
        </Modal>
      )}
      {showUpdateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Update work`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateWork
            setShowUpdateForm={setShowUpdateForm}
            targetID={targetID}
            triggerFetch={triggerFetch}
            api={api}
            types={enums}
          />
        </Modal>
      )}

      {showViewSection && (
        <Modal
          extraClass={"small"}
          modalHeading={`View works`}
          setShowModalContent={setShowViewSection}
        >
          <ViewWork targetID={targetID} api={api} />
        </Modal>
      )}
    </div>
  );
}

export default OurWorks;
